import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons/faArrowRotateRight'
import CustomButton from '@space-core/components/customButton'
import { customMedia } from '@space-core/styles'
import styled from 'styled-components'

export type ErrorPopupProps = {
  title: string
  description: string
  textButton: string
  onTryAgain: () => void
  instruction?: string
}

export const Wrapper = styled.div`
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;

  ${customMedia.greaterThan('md')`
    width: 34rem;
  `}
`

const Button = styled(CustomButton)`
  min-width: 8.125rem;
`

const ErrorPopup = ({
  title,
  description,
  textButton,
  onTryAgain,
  instruction
}: ErrorPopupProps) => {
  return (
    <Wrapper className='_d-flex _flex-column _justify-content-center _align-items-center _bg-primary _rounded-lg _shadow-lg _p-5 _position-absolute'>
      <h2 className='_text-2 _text-gray-900 _font-weight-bold _mb-1 _text-center'>{title}</h2>
      <p className='_text-1 _text-md-2 _text-gray-900 _font-weight _text-center _m-0'>
        {description}
      </p>
      {instruction ? (
        <p
          className='_text-1 _text-md-2 _text-gray-900 _font-weight _text-center _m-0'
          data-test='instruction'>
          {instruction}
        </p>
      ) : null}
      <Button
        onClick={onTryAgain}
        icon={faArrowRotateRight}
        className='_d-flex _justify-content-center _align-items-center _mt-5 _text-1 _text-md-2'>
        {textButton}
      </Button>
    </Wrapper>
  )
}

export default ErrorPopup
